import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { DataService } from '../../common/data.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IBPRecord, IStatus, Roles } from '../../model/bp-record';
import { AppTokenHandler } from '../../common/app-token-handler';
import { LazyLoadEvent } from 'primeng/api';
import SimpleCrypto from "simple-crypto-js";

@Component({
  selector: 'app-bprecords',
  templateUrl: './bprecords.component.html',
  styleUrls: ['./bprecords.component.css']
})
export class BPRecordsComponent implements OnInit {
  first: number = 0;
  loading: boolean = false;
  totalRecords: number;
  cols: any[];
  roles = Roles;
  BPRecordList: Array<IBPRecord> = [];
  SelectedBPRecord: Array<IBPRecord> = [];

  userGpn: any = '';
  paramAll: any = '';
  paramIsMy: any = '';
  paramIsClient: any = '';
  paramIsDpc: any = '';
  sortOrder: number = 1; // 1 for descending, 2 for descending

  isStatusHideorShow: boolean = false;

  constructor(
    private cdref: ChangeDetectorRef,
    private bpRecordService: DataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private appToken: AppTokenHandler,
    private _fb: FormBuilder) { }

  ngAfterContentChecked() {

    this.cdref.detectChanges();

  }

  paginate(event) {
    this.first = event.first;
  }

  onClickMdmId(id) {
    let encriptedId = this.bpRecordService.EncryptData(id);
    if (this.paramAll) {
      if (this.paramIsClient) {
        this.router.navigate(['/home/bprecorddetail'], { queryParams: { id: encriptedId, isall: true, isclient: true } });
      } else if (this.paramIsDpc) {
        this.router.navigate(['/home/bprecorddetail'], { queryParams: { id: encriptedId, isall: true, isdpc: true } });
      } else {
        this.router.navigate(['/home/bprecorddetail'], { queryParams: { id: encriptedId, isall: true } });
      }

    } else if (this.paramIsMy && this.paramIsClient) {
      this.router.navigate(['/home/bprecorddetail'], { queryParams: { id: encriptedId, ismy: true, isclient: true } });
    } else if (this.paramIsClient) {
      this.router.navigate(['/home/bprecorddetail'], { queryParams: { id: encriptedId, isclient: true } });
    } else if (this.paramIsDpc) {
      this.router.navigate(['/home/bprecorddetail'], { queryParams: { id: encriptedId, isdpc: true } });
    }

    //this.router.navigate(['/home/bprecorddetail'], { queryParams: { id: id, from: this.pa } });
  }

  onClickEccId(id) {
    let encriptedId = this.bpRecordService.EncryptData(id);
    if (this.paramAll) {
      if (this.paramIsClient) {
        this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, isall: true, isclient: true } });
      } else if (this.paramIsDpc) {
        this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, isall: true, isdpc: true } });
      } else {
        this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, isall: true } });
      }

    } else if (this.paramIsMy && this.paramIsClient) {
      this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, ismy: true, isclient: true } });
    } else if (this.paramIsClient) {
      this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, isclient: true } });
    } else if (this.paramIsDpc) {
      this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, isdpc: true } });
    }

    //this.router.navigate(['/home/ecciddetails'], { queryParams: { id: id } });
  }

  filterForm: FormGroup = this._fb.group({
    MdmId: [''],
    EccId: [''],
    Status: [''],
    ProspectSubmitter: [''],
    BPName: ['']
  });

  mdmStatusList: Array<IStatus> = [
    {
      Id: 0,
      Name: '-- select --',
    },
    {
      Id: 1,
      Name: 'Pending with Client server',
    },
    {
      Id: 2,
      Name: 'Pending with DPC for review',
    },
    {
      Id: 3,
      Name: 'Reviewed',
    }
  ];

  ngOnInit() {
    this.cols = [
      { field: 'MdmId', header: 'BP Code' },
      { field: 'EccId', header: 'ECC ID' },
      { field: 'BPName', header: 'BP Name' },
      { field: 'BPClassification', header: 'Customer Classification' },
      { field: 'BPCountry', header: 'BP Country' },
      { field: 'Pace_ID', header: 'Pace ID' },
      { field: 'ProspectSubmitter', header: 'Prospect Submitter' },
      { field: 'MdmStatus', header: 'Mdm Status' },
      { field: 'EccStatus', header: 'Ecc Status' }
    ];


    // this.loadData(false);
  }

  /// load and filtering bp records 
  loadData(event: LazyLoadEvent) {
    this.userGpn = this.appToken.getLoginUserInfo().EmpGPN;
    this.paramAll = this.activatedRoute.snapshot.queryParamMap.get('isall');
    this.paramIsMy = this.activatedRoute.snapshot.queryParamMap.get('ismy');
    this.paramIsClient = this.activatedRoute.snapshot.queryParamMap.get('isclient');
    this.paramIsDpc = this.activatedRoute.snapshot.queryParamMap.get('isdpc');

    if (this.paramIsDpc && this.paramAll) {
      this.mdmStatusList = [
        {
          Id: 0,
          Name: '-- select --',
        },

        {
          Id: 2,
          Name: 'Pending with DPC for review',
        },
        {
          Id: 3,
          Name: 'Reviewed',
        }
      ];
    }

    // this.loading = true;
    let filterObj: any = {};

    filterObj = {
      MdmId: this.f.MdmId.value ? this.f.MdmId.value : null,
      EccId: this.f.EccId.value ? this.f.EccId.value : null,
      MdmStatus: this.f.Status.value ? this.f.Status.value.Id : 0,
      EccStatus: this.f.Status.value ? this.f.Status.value.Id : 0,
      ProspectSubmitter: this.f.ProspectSubmitter && this.f.ProspectSubmitter.value ? this.f.ProspectSubmitter.value : null,
      BPName: this.f.BPName.value ? this.f.BPName.value : null
    }

    if (this.paramIsMy && this.paramIsClient) {
      filterObj.ProspectSubmitterGPN = this.userGpn;
    } else if (this.paramAll && this.paramIsDpc) {
      filterObj.ParamAll = 1;
      filterObj.ParamIsDpc = 1;
      filterObj.MdmStatus = 2;
      filterObj.EccStatus = 2;
    } else if (this.paramAll) {
      filterObj.ParamAll = 1
    } else if (this.userHasRole(this.roles.ProspectSubmitter) && this.paramIsClient) {
      filterObj.ParamIsClient = 1;
      filterObj.ProspectSubmitterGPN = this.userGpn;
      filterObj.MdmStatus = 1;
      filterObj.EccStatus = 1;
    } else if (this.userHasRole(this.roles.DPC) && this.paramIsDpc) {
      filterObj.ParamIsDpc = 1;
      filterObj.MdmStatus = 2;
      filterObj.EccStatus = 2;
    }

    //paging
    filterObj.Offset = event.first;
    filterObj.NoOfRows = event.rows
    filterObj.SortBy = event.sortField ? event.sortField : 'MdmId';

    this.sortOrder = this.sortOrder == 1 ? 2 : 1;  // 1 for descending, 2 for ascending

    if (!event.sortField) {
      this.sortOrder = 1
    }

    filterObj.SortOrder = this.sortOrder;

    this.bpRecordService.PostData('GetBPRecords', filterObj).subscribe(
      (data: any) => {
        this.BPRecordList = data;
        this.totalRecords = data.length > 0 ? data[0].TotalRows : 0
        this.loading = false;
      }, _error => {
        this.loading = false;
      }
    );
  }

  exportExcel(selectionOnly: boolean) {
    let list = selectionOnly ? this.SelectedBPRecord : this.BPRecordList;

    let excelRecords = list.map(a => {
      let MdmStatusText = ''
      switch (a.MdmStatus) {
        case 1: MdmStatusText = 'Pending with Client server'
          break;
        case 2: MdmStatusText = 'Pending with DPC for review'
          break;
        case 3: MdmStatusText = 'Reviewed'
          break;
      }

      let EccStatusText = ''
      switch (a.EccStatus) {
        case 1: EccStatusText = 'Pending with Client server'
          break;
        case 2: EccStatusText = 'Pending with DPC for review'
          break;
        case 3: EccStatusText = 'Reviewed'
          break;
      }

      return {
        'Business Partner Code': a.MdmId,
        'ECC ID': a.EccId,
        'Business Partner Name': a.BPName,
        'Customer Classification': a.BPClassification,
        'Business Partner Country': a.BPCountry,
        'Pace ID': a.Pace_ID,
        'Prospect Submitter': a.ProspectSubmitter,
        'MdmStatus': MdmStatusText,
        'EccStatus': EccStatusText
      }
    })

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(excelRecords);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "BPRecords");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  userHasRole(roleId: number) {
    let visible: boolean = false;
    if (this.appToken.IsInRole(Roles[roleId])) {
      visible = true;
    }
    return visible;
  }


  resetAll() {
    this.filterForm.reset();
    this.loadData({ first: 0, rows: 10 });
  }


  get f() {
    return this.filterForm.controls;
  }

  buttonHideOrShow() {
    this.isStatusHideorShow = this.paramIsClient == true ? true : false;
  }



}
